import { HeadingTwoText } from '@mint/ui';
import styled from 'styled-components';

export const AdminPanelHeadingTwoText = styled(HeadingTwoText)`
  :first-child {
    margin-top: 1rem;
  }
`;
